import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { NAV_CATEGORIES } from '../api/woocommerce';

const LOGO_URL = '/logo-red.png';

export default function Footer() {
  const navigate = useNavigate();
  return (
    <>
      <style>{`
        .footer { background: #d71921; padding: 60px 46px 0; }
        .footer-inner {
          display: grid;
          grid-template-columns: 2fr 1fr 1fr 1fr;
          gap: 40px;
          max-width: 1400px;
          margin: 0 auto;
        }
        .footer-logo { height: 40px; width: auto; max-width: 160px; object-fit: contain; display: block; margin-bottom: 16px; }
        .footer-logo2 { width: 100%; max-width: 338px; height: auto; object-fit: contain; display: block; }
        .footer-address {
          font-family: 'Roboto', sans-serif;
          font-weight: 300;
          font-size: 16px;
          color: #fff;
          line-height: 1.6;
        }
        .footer-heading {
          font-family: 'Alumni Sans', sans-serif;
          font-weight: 600;
          font-size: 24px;
          color: #fff;
          margin-bottom: 14px;
        }
        .footer-link {
          font-family: 'Roboto', sans-serif;
          font-weight: 300;
          font-size: 16px;
          color: #fff;
          display: block;
          margin-bottom: 8px;
          cursor: pointer;
          transition: opacity 0.2s;
        }
        .footer-link:hover { opacity: 0.7; }
        .footer-social { display: flex; gap: 14px; margin-top: 10px; }
        .footer-social img { width: 28px; height: 28px; cursor: pointer; }
        .footer-cta-btn {
          background: #fff;
          color: #d71921;
          font-family: 'Alumni Sans', sans-serif;
          font-weight: 600;
          font-size: 18px;
          padding: 10px 24px;
          margin-top: 16px;
          display: inline-block;
          cursor: pointer;
          border: none;
          transition: opacity 0.2s;
        }
        .footer-bottom {
          background: #000;
          margin-top: 40px;
          margin-left: -46px;
          margin-right: -46px;
          padding: 12px 0;
          text-align: center;
        }
        .footer-copy {
          font-family: 'Roboto', sans-serif;
          font-weight: 300;
          font-size: 13px;
          color: #fff;
        }

        @media (max-width: 900px) {
          .footer { padding: 40px 20px 0; }
          .footer-inner {
            grid-template-columns: 1fr 1fr;
            gap: 32px;
          }
          .footer-bottom { margin-left: -20px; margin-right: -20px; }
        }
        @media (max-width: 500px) {
          .footer-inner {
            grid-template-columns: 1fr;
            gap: 28px;
          }
        }
      `}</style>

      <footer className="footer">
        <div className="footer-inner">
          <div style={{display:'flex', alignItems:'center', justifyContent:'flex-start', paddingLeft:'0', height:'100%'}}>
            <img src="/logo white copia.png" alt="Falcon" className="footer-logo2" />
          </div>
          <div>
            <p className="footer-heading">Sitemap</p>
            {NAV_CATEGORIES.map(cat => (
              <Link key={cat} to={`/categoria/${cat.toLowerCase().replace(/ & /g,'-').replace(/ /g,'-')}`} className="footer-link">{cat}</Link>
            ))}
          </div>
          <div>
            <p className="footer-heading">Informazioni Legali</p>
            <Link to="/cookie-policy" className="footer-link">Cookie Policy</Link>
            <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
          
          </div>
          <div>
            <p className="footer-heading">Seguici sui social</p>
            <div className="footer-social">
              <a href="https://www.instagram.com/falcon_fishing_italia/" target="_blank" rel="noreferrer">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28" fill="#fff">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.334 3.608 1.308.974.975 1.245 2.242 1.307 3.608.058 1.265.07 1.645.07 4.851s-.012 3.584-.07 4.85c-.062 1.366-.334 2.633-1.308 3.608-.975.974-2.242 1.245-3.608 1.307-1.265.058-1.645.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.334-3.608-1.308-.974-.975-1.245-2.242-1.307-3.608C2.175 15.584 2.163 15.204 2.163 12s.012-3.584.07-4.85c.062-1.366.334-2.633 1.308-3.608C4.516 2.497 5.783 2.226 7.149 2.164 8.415 2.106 8.795 2.163 12 2.163zm0-2.163C8.741 0 8.333.013 7.053.072 5.197.157 3.355.673 2.014 2.014.673 3.355.157 5.197.072 7.053.013 8.333 0 8.741 0 12c0 3.259.013 3.668.072 4.948.085 1.856.6 3.698 1.942 5.038 1.34 1.341 3.182 1.857 5.038 1.942C8.333 23.987 8.741 24 12 24s3.668-.013 4.948-.072c1.856-.085 3.698-.6 5.038-1.942 1.341-1.34 1.857-3.182 1.942-5.038.059-1.28.072-1.689.072-4.948s-.013-3.667-.072-4.947c-.085-1.856-.6-3.698-1.942-5.038C20.646.673 18.804.157 16.948.072 15.668.013 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
                </svg>
              </a>
              <a href="https://www.facebook.com/FalconFishingItalia" target="_blank" rel="noreferrer">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28" fill="#fff">
                  <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.97h-1.513c-1.491 0-1.956.93-1.956 1.884v2.27h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
                </svg>
              </a>
            </div>
            <button className="footer-cta-btn" onClick={() => navigate({ pathname: '/', hash: '#contatti' })}>Contattaci Ora</button>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="footer-copy">
            © 2026 Falcon, All Right Reserved – Powered by MIRAI BAY –{' '}
            <a href="https://www.behance.net/MarcoFerrara" target="_blank" rel="noreferrer" style={{textDecoration:'underline',color:'#fff'}}>Credits</a>
          </p>
        </div>
      </footer>
    </>
  );
}
